/**
 * Gravity Form
 * Adds Material Design Floating Labels on Gravity Forms
 * @dependencies jquery https://jquery.com/
 */

import $ from 'jquery';

/**
 * Init post render (and reinit after ajax error / success)
 * @url https://docs.gravityforms.com/gform_post_render/
 */
$(document).on('gform_post_render', function(event, form_id, current_page){

  // Remove Loading class if exists
  document.body.classList.remove('is-loading');

  // Add readOnly attribute to readonly classed fields
  const readOnlyFields = document.querySelectorAll('.readonly input');
  if (readOnlyFields.length) {
    for (const readOnlyField of readOnlyFields) {
      readOnlyField.readOnly = true;
    }
  }
});

// Disable checkboxes when field is over a given number of choices.
$( ".gform_wrapper form" ).on( 'click', 'input[type="checkbox"]', function( event ) {
  disable_checkboxes( $( this ).closest( '.gfield_checkbox' ).attr( 'id' ) );
});

disable_checkboxes( 'input_9_25' );
disable_checkboxes( 'input_9_32' );

function disable_checkboxes( parent ) {
  var nb_to_check = 0;
  if ( -1 != parent.indexOf( '25' ) ) {
    nb_to_check = ch_js.provider_form.skill_max_num;
  } else if ( -1 != parent.indexOf( '32' )  ) {
    nb_to_check = ch_js.provider_form.sub_skill_max_num;
  }

  if ( nb_to_check == 0 )
    return;

  if ( nb_to_check <= $( '#' + parent + ' input[type="checkbox"]:checked' ).length ) {
    $( '#' + parent + ' input[type="checkbox"]:not(:checked)' ).attr('disabled', true);
  } else {
    $( '#' + parent + ' input[type="checkbox"]:not(:checked)' ).removeAttr( "disabled" );
  }
}
